import React, { useState } from "react";
import "../../styles/audiobook/SaveRecordingModal.scss";
import useAppTranslation from "../../hooks/useAppTranslation";

const SaveRecordingModal = ({ onSave, onCancel }) => {
  const { t } = useAppTranslation("components/audiobook/saveRecordingModal");
  const [title, setTitle] = useState("");

  const handleSubmit = () => {
    if (!title.trim()) {
      alert(t("alerts.enterTitle"));
      return;
    }
    onSave(title);
  };

  return (
    <div className="save-recording-modal">
      <div className="inner">
        <div className="recording-title-box">
          <h2>{t("title")}</h2>
          <p>
            {t("description.line1")} <br /> {t("description.line2")}
          </p>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder={t("placeholder")}
          />
          <div className="recording-btns">
            {/* <button
                            onClick={onCancel}
                            className="close-modal-btn"
                        >
                            <img
                                src={'/images/audiobook/close-modal-btn.svg'}
                                alt=""
                            />
            </button> */}
            <button onClick={handleSubmit} className="save-audio-book">
              <img src={"/images/utils/save.svg"} alt={t("actions.save")} />
              <span>{t("actions.save")}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaveRecordingModal;
